module.exports = __webpack_public_path__ + "b5784ffca85e9b479a73640e728f6914.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/animals/eagle.svg
// module id = 85
// module chunks = 0